// src/components/ProductServices.js
import React, { useState, useEffect, useRef } from 'react';
import './ProductServices.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faBoxOpen, faShoppingCart, faFileInvoiceDollar, faChartLine, faWarehouse, faTools, faUndoAlt, faTruck, faFileContract, faPiggyBank } from '@fortawesome/free-solid-svg-icons';

const ProductServices = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const currentRef = sectionRef.current; // Guardamos el valor de sectionRef.current en una variable

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.2 } // Se activa cuando el 20% del componente es visible
    );

    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  return (
    <div className="product-services" ref={sectionRef}>
      <h2 className="section-title">Nuestros Productos y Servicios</h2>
      <div className="services-container">
        <div className={`service-card ${isVisible ? 'animate__animated animate__fadeInUp' : ''}`}>
          <FontAwesomeIcon icon={faUser} className="service-icon" />
          <h3>Gestión de Clientes y Proveedores</h3>
          <p>Registro y administración completa de clientes y proveedores, con informes detallados que permiten un control total de las relaciones comerciales.</p>
        </div>
        <div className={`service-card ${isVisible ? 'animate__animated animate__fadeInUp animate__delay-1s' : ''}`}>
          <FontAwesomeIcon icon={faBoxOpen} className="service-icon" />
          <h3>Administración de Productos</h3>
          <p>Controla el stock en tiempo real, registra productos con detalles completos y utiliza filtros avanzados para gestionar tu inventario de manera eficiente.</p>
        </div>
        <div className={`service-card ${isVisible ? 'animate__animated animate__fadeInUp animate__delay-2s' : ''}`}>
          <FontAwesomeIcon icon={faShoppingCart} className="service-icon" />
          <h3>Gestión de Ventas y Órdenes</h3>
          <p>Crea y sigue órdenes de venta, genera facturas en PDF de manera automática, y lleva un control preciso de las ventas realizadas en cualquier momento.</p>
        </div>
        <div className={`service-card ${isVisible ? 'animate__animated animate__fadeInUp animate__delay-3s' : ''}`}>
          <FontAwesomeIcon icon={faFileInvoiceDollar} className="service-icon" />
          <h3>Control de Compras e Integración AFIP</h3>
          <p>Administra tus compras e integración con proveedores, genera facturas electrónicas válidas en ARCA con emisión de CAE, y automatiza procesos fiscales.</p>
        </div>
        <div className={`service-card ${isVisible ? 'animate__animated animate__fadeInUp animate__delay-4s' : ''}`}>
          <FontAwesomeIcon icon={faWarehouse} className="service-icon" />
          <h3>Control de Stock y Vencimientos</h3>
          <p>Monitorea continuamente el stock y recibe alertas sobre productos que están por vencer, manteniendo siempre al día tu inventario con máxima precisión.</p>
        </div>
        <div className={`service-card ${isVisible ? 'animate__animated animate__fadeInUp animate__delay-5s' : ''}`}>
          <FontAwesomeIcon icon={faChartLine} className="service-icon" />
          <h3>Estadísticas, Reportes y Análisis de Ganancias</h3>
          <p>Accede a gráficos dinámicos, análisis comparativos y estadísticas detalladas sobre ventas, ganancias por producto y evolución del negocio.</p>
        </div>
        <div className={`service-card ${isVisible ? 'animate__animated animate__fadeInUp animate__delay-6s' : ''}`}>
          <FontAwesomeIcon icon={faTruck} className="service-icon" />
          <h3>Guías de Reparto y Entrega</h3>
          <p>Genera guías de reparto automáticas, controla el seguimiento de entregas y optimiza las rutas de distribución para mejorar la eficiencia operativa.</p>
        </div>
        <div className={`service-card ${isVisible ? 'animate__animated animate__fadeInUp animate__delay-1s' : ''}`}>
          <FontAwesomeIcon icon={faUndoAlt} className="service-icon" />
          <h3>Sistema de Devoluciones</h3>
          <p>Gestiona devoluciones de productos de forma sencilla, reajusta automáticamente el stock y mantén registros completos de todas las transacciones inversas.</p>
        </div>
        <div className={`service-card ${isVisible ? 'animate__animated animate__fadeInUp animate__delay-2s' : ''}`}>
          <FontAwesomeIcon icon={faFileContract} className="service-icon" />
          <h3>Notas de Crédito y Gestión de Devoluciones</h3>
          <p>Emite notas de crédito automáticas para devoluciones y ajustes, con generación de documentos fiscales válidos y seguimiento de créditos otorgados.</p>
        </div>
        <div className={`service-card ${isVisible ? 'animate__animated animate__fadeInUp animate__delay-3s' : ''}`}>
          <FontAwesomeIcon icon={faPiggyBank} className="service-icon" />
          <h3>Control de Deudas de Clientes</h3>
          <p>Monitorea las deudas pendientes, genera alertas de vencimientos, y mantén una gestión actualizada de los créditos otorgados a cada cliente.</p>
        </div>
        <div className={`service-card ${isVisible ? 'animate__animated animate__fadeInUp animate__delay-4s' : ''}`}>
          <FontAwesomeIcon icon={faTools} className="service-icon" />
          <h3>Actualizaciones y Asistencia Técnica</h3>
          <p>Oferecemos actualizaciones continuas, soporte personalizado y asistencia técnica adaptada a tus necesidades específicas para mantener el sistema siempre optimizado.</p>
        </div>
      </div>
    </div>
  );
};

export default ProductServices;


